<template>
  <div>
    <div class="personCenter">
      <div class="personCenter_content">
        <ul class="personCenter_content_left">
          <li
            v-for="(item, index) in navsArr"
            :key="index"
            :class="{ nav_item_s: selectType == index + 1 }"
            @click="handleNavItem(index)"
          >
            <div class="nav_item">
              <img
                :src="item.img"
                v-if="selectType !== index + 1"
                alt=""
                class="icon"
              />
              <img :src="item.img_s" v-else alt="" class="icon" />
              <div>{{ item.text }}</div>
            </div>
          </li>
          <!-- <li>
            <div class="nav_item">
              <img src="../assets/images/set_s.png" alt="">
              <div>账户设置</div>
            </div>
          </li> -->
        </ul>
        <div class="personCenter_content_right">
          <template v-if="selectType == 1">
            <div class="content_right_box">
              <div>
                <div class="right_item_title">用户名</div>
                <div class="right_item_detail">
                  <div class="right_item_detail_lf">
                    <img
                      src="../assets/images/userName.png"
                      alt=""
                      class="icon"
                    />
                    <div>{{ userInfo.username }}</div>
                  </div>
                </div>
              </div>
              <div>
                <div class="right_item_title">会员有效期</div>
                <div class="right_item_detail" v-if="userInfo.memberFlag">
                  <div class="right_item_detail_lf">
                    <img
                      src="../assets/images/membershipTime.png"
                      alt=""
                      class="icon"
                    />
                    <div>{{ userInfo.memberExpirationDate }}</div>
                  </div>
                  <div class="right_item_detail_rt" @click="handleRenew">
                    立即续费
                  </div>
                </div>
                <div class="right_item_detail" v-else>
                  <div class="right_item_detail_lf">
                    <img
                      src="../assets/images/e_membershipTime.png"
                      alt=""
                      class="icon"
                    />
                    <div>未开通会员</div>
                  </div>
                  <div class="right_item_detail_rt" @click="handleRenew">
                    开通会员
                  </div>
                </div>
              </div>
              <div>
                <div class="right_item_title">昵称</div>
                <div class="right_item_detail">
                  <div class="right_item_detail_lf">
                    <img
                      src="../assets/images/userName.png"
                      alt=""
                      class="icon"
                    />
                    <div>{{ userInfo.name }}</div>
                  </div>
                  <div class="right_item_detail_rt" @click="handleEditNick">
                    编辑
                  </div>
                </div>
              </div>
              <div>
                <div class="right_item_title">手机号</div>
                <div class="right_item_detail">
                  <div class="right_item_detail_lf">
                    <img
                      src="../assets/images/userName.png"
                      alt=""
                      class="icon"
                    />
                    <div v-if="userInfo.phone">
                      {{
                        userInfo.phone.slice(0, 3) +
                        "****" +
                        userInfo.phone.slice(-4)
                      }}
                    </div>
                  </div>
                  <div class="right_item_detail_rt" @click="handleEditPhone">
                    修改
                  </div>
                </div>
              </div>
              <div>
                <div class="right_item_title">密码</div>
                <div class="right_item_detail">
                  <div class="right_item_detail_lf">
                    <img
                      src="../assets/images/password.png"
                      alt=""
                      class="icon"
                    />
                    <div>******</div>
                  </div>
                  <div class="right_item_detail_rt" @click="handleEditPsw">
                    修改
                  </div>
                </div>
              </div>
              <div class="loginOut_box">
                <button class="loginOut" @click="handleLoginOut">
                  退出登录
                </button>
              </div>
            </div>
          </template>
          <template v-else-if="selectType == 2">
            <div class="content_right_box">
              <div>
                <div class="right_item_title">创建的商家</div>
                <div class="right_item_detail">
                  <div class="right_item_detail_lf" v-if="!userInfo.mchName">
                    <img
                      src="../assets/images/e_merchant.png"
                      alt=""
                      class="icon"
                    />
                    <div>未创建商家</div>
                  </div>
                  <div class="right_item_detail_lf" v-else>
                    <img
                      src="../assets/images/merchant.png"
                      alt=""
                      class="icon"
                    />
                    <div>{{ userInfo.mchName }}</div>
                  </div>
                  <div
                    class="right_item_detail_rt"
                    v-if="!userInfo.mchName"
                    @click="handleCreateMch"
                  >
                    立即创建
                  </div>
                </div>
              </div>
              <div>
                <div class="right_item_title">关联的商家</div>
                <div class="right_item_detail">
                  <div class="right_item_detail_lf">
                    <img
                      src="../assets/images/merchant.png"
                      alt=""
                      class="icon"
                    />
                    <div>{{ userInfo.relationMchName }}</div>
                  </div>
                  <div
                    class="right_item_detail_rt"
                    v-if="userInfo.relationMchName"
                    @click="handleOpenWindow"
                  >
                    登录商家后台
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else-if="selectType == 3">
            <div class="scroll_none">
              <!-- 订单记录 -->
              <!-- pc -->
              <table
                width="96%"
                style="border-collapse: collapse"
                border="1"
                align="center"
              >
                <tr>
                  <th colspan="1" height="45px">
                    <div class="th-div" style="">
                      <div>订单编号</div>
                    </div>
                  </th>
                  <th colspan="1" height="45px">
                    <div class="th-div" style="">
                      <div>订单内容</div>
                    </div>
                  </th>
                  <th colspan="1" height="45px">
                    <div class="th-div" style="">
                      <div>订单金额</div>
                    </div>
                  </th>
                  <th colspan="1" height="45px">
                    <div class="th-div" style="">
                      <div>优惠券（元）</div>
                    </div>
                  </th>
                  <th colspan="1" height="45px">
                    <div class="th-div" style="">
                      <div>支付金额（元）</div>
                    </div>
                  </th>
                  <th colspan="1" height="45px">
                    <div class="th-div" style="">
                      <div>支付时间</div>
                    </div>
                  </th>
                  <th colspan="1" height="45px">
                    <div class="th-div" style="">
                      <div>支付方式</div>
                    </div>
                  </th>
                </tr>
                <template v-if="orderTableData.length">
                  <tr
                    v-for="(item, index) in orderTableData"
                    :key="index"
                    class="body_tr"
                  >
                    <td class="table-td1">{{ item.orderNo || "——" }}</td>
                    <td class="table-td1">{{ item.content || "——" }}</td>
                    <td class="table-td1">{{ item.price || "——" }}</td>
                    <td class="table-td1">{{ item.couponAmount || "——" }}</td>
                    <td class="table-td1">{{ item.paidPrice || "——" }}</td>
                    <td class="table-td1">{{ item.payTime || "——" }}</td>
                    <td class="table-td1">
                      {{
                        item.payType && item.payType == 10 ? "支付宝" : "微信"
                      }}
                    </td>
                  </tr>
                </template>
              </table>
              <!-- 移动端 -->
              <div class="mOrderRecord_box">
                <template v-if="orderTableData.length">
                  <div
                    class="mOrderRecord_item"
                    v-for="(item, index) in orderTableData"
                    :key="index"
                  >
                    <div class="mOrderRecord_item_lf">
                      <div class="mOrderRecord_item_lf_name">
                        {{ item.content || "——" }}
                      </div>
                      <div class="mOrderRecord_item_lf_date">
                        支付时间：{{ item.payTime || "——" }}
                      </div>
                    </div>
                    <div
                      class="mOrderRecord_item_rt"
                      @click="hadnleOrderRecord(item)"
                    >
                      查看详情 >
                    </div>
                  </div>
                </template>
              </div>
              <div class="tableNone" v-if="!orderTableData.length">
                暂无数据
              </div>
            </div>
          </template>
          <template v-else-if="selectType == 4">
            <div class="scroll_none">
              <div class="selectType4_params">
                <span @click="handleUseStatus">{{
                  useStatus == 1 ? "查看不可用优惠券 >" : "查看可用优惠券 >"
                }}</span>
              </div>
              <!-- 优惠券pc -->
              <table
                width="96%"
                style="border-collapse: collapse"
                border="1"
                align="center"
              >
                <tr>
                  <th colspan="1" height="45px">
                    <div class="th-div" style="">
                      <div>优惠券金额（元）</div>
                    </div>
                  </th>
                  <th colspan="1" height="45px">
                    <div class="th-div" style="">
                      <div>优惠券名称</div>
                    </div>
                  </th>
                  <th colspan="1" height="45px">
                    <div class="th-div" style="">
                      <div>状态</div>
                    </div>
                  </th>
                </tr>
                <template>
                  <tr
                    v-for="(item, index) in dataList"
                    :key="index"
                    class="body_tr"
                  >
                    <td class="table-td1">{{ item.amount || "——" }}</td>
                    <td class="table-td1">
                      <div class="table-td1_name">{{ item.name }}</div>
                      <div class="table-td1_qixian">
                        有效期：{{ item.startTime || "——" }}至{{
                          item.endTime || "——"
                        }}
                      </div>
                    </td>
                    <td
                      class="table-td1"
                      v-if="useStatus == 1"
                      style="color: #6696ff; cursor: pointer"
                      @click="handleUse(item)"
                    >
                      去使用
                    </td>
                    <td class="table-td1" v-else style="color: #c0c4cc">
                      {{ item.statusName }}
                    </td>
                  </tr>
                </template>
              </table>

              <!-- 优惠券移动端 -->
              <div class="coupon_box">
                <template>
                  <div
                    class="coupon_item"
                    v-for="(item, index) in dataList"
                    :key="index"
                  >
                    <div class="coupon_item_lf">
                      <div
                        class="coupon_item_lf_lf"
                        :class="{ useStatus1: useStatus == 1 }"
                      >
                        <span class="coupon_item_lf_lf_fuhao">￥</span
                        >{{ item.amount }}
                      </div>
                      <div class="coupon_item_lf_rt">
                        <div class="coupon_item_lf_rt_name">
                          {{ item.name || "——" }}
                        </div>
                        <div class="coupon_item_lf_rt_date">
                          有效期：{{ item.startTime || "——" }}至{{
                            item.endTime || "——"
                          }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="coupon_item_rt"
                      v-if="useStatus == 1"
                      @click="handleUse(item)"
                    >
                      去使用
                    </div>
                    <div v-else style="color: #c0c4cc">
                      {{ item.statusName }}
                    </div>
                  </div>
                </template>
              </div>
              <div class="tableNone" v-if="!dataList.length">暂无数据</div>
              <div class="loadingMore" v-if="dataList.length >= 15">
                <span v-if="hasNextPage">
                  <span v-if="mLoading">~~ 正在加载 ~~</span>
                  <span v-else @click="handleLoadingMore"
                    >~~ 点击加载更多 ~~</span
                  >
                </span>
                <span v-else>~~ 没有更多了 ~~</span>
              </div>
            </div>
          </template>
        </div>
      </div>
      <!-- <div @click="fuck">fuck</div>
      <div @click="fuck01">fuck01</div>
      <div @click="fuck02">fuck02</div> -->
      <modelMask :showModal.sync="showModal" :title="title">
        <template v-if="selectType == 1">
          <template v-if="editType == 1"> </template>
          <template v-else-if="editType == 2">
            <div slot="body">
              <div class="form-container-item">
                <div class="item-content item_content_mg_lf">
                  <div class="item-input-box">
                    <input
                      v-model="userData.name"
                      maxlength="8"
                      type="text"
                      prop="name"
                      placeholder="请输入昵称"
                      :class="{ errorRules: modelControl_name }"
                      class="input__inner"
                    />
                    <div class="error-message" v-if="modelControl_name">
                      {{ modelControl_name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div slot="footer">
              <button class="btn btn-secondary" @click="showModal = false">
                取消
              </button>
              <button
                type="button"
                class="btn btn-primary"
                @click="handleSubName"
              >
                确定
              </button>
            </div>
          </template>
          <template v-else-if="editType == 3">
            <div slot="body">
              <template v-if="handleSubCodeStepType == 1">
                <div class="form-container-item">
                  <div class="item-content item_content_mg_lf">
                    <div class="item-input-box">
                      <div class="flex-between">
                        <input
                          v-model="userData.code"
                          maxlength="6"
                          type="text"
                          prop="code"
                          placeholder="请输入验证码"
                          :class="{ errorRules: modelControl_code }"
                          class="input__inner"
                        />
                        <button
                          class="getcode-button"
                          :class="{ isSendCodeActive: isSendCodeActive }"
                          @click.prevent="sendCode"
                          :disabled="isSendCodeActive"
                        >
                          {{ sendCodeText }}
                        </button>
                      </div>
                      <div class="error-message" v-if="modelControl_code">
                        {{ modelControl_code }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="handleSubCodeStepType == 2">
                <div class="form-container-item">
                  <div class="item-content item_content_mg_lf">
                    <div class="item-input-box">
                      <input
                        v-model="userData.newPhone"
                        maxlength="11"
                        type="text"
                        prop="newPhone"
                        placeholder="请输入新手机号码"
                        :class="{ errorRules: modelControl_newPhone }"
                        class="input__inner"
                      />
                      <div class="error-message" v-if="modelControl_newPhone">
                        {{ modelControl_newPhone }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div slot="footer">
              <template v-if="handleSubCodeStepType == 1">
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="handleSubCodeStep2"
                >
                  下一步
                </button>
              </template>
              <template v-if="handleSubCodeStepType == 2">
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="handleSubCode"
                >
                  确定
                </button>
              </template>
            </div>
          </template>
          <template v-else-if="editType == 4">
            <div slot="body">
              <template v-if="handleSubPwdStepType == 1">
                <div class="form-container-item">
                  <div class="item-content item_content_mg_lf">
                    <div class="item-input-box">
                      <input
                        v-model="userData.password"
                        maxlength="11"
                        type="text"
                        prop="password"
                        placeholder="请输入原密码"
                        :class="{ errorRules: modelControl_password }"
                        class="input__inner"
                      />
                      <div class="error-message" v-if="modelControl_password">
                        {{ modelControl_password }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="handleSubPwdStepType == 2">
                <div class="form-container-item">
                  <div class="item-content item_content_mg_lf">
                    <div class="item-input-box">
                      <input
                        v-model="userData.newPassword"
                        maxlength="11"
                        type="text"
                        prop="newPassword"
                        placeholder="请输入新密码"
                        :class="{ errorRules: modelControl_newPassword }"
                        class="input__inner"
                      />
                      <div
                        class="error-message"
                        v-if="modelControl_newPassword"
                      >
                        {{ modelControl_newPassword }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-container-item">
                  <div class="item-content item_content_mg_lf">
                    <div class="item-input-box">
                      <input
                        v-model="userData.newPassword2"
                        maxlength="11"
                        type="text"
                        prop="newPassword2"
                        placeholder="确认密码"
                        :class="{ errorRules: modelControl_newPassword2 }"
                        class="input__inner"
                      />
                      <div
                        class="error-message"
                        v-if="modelControl_newPassword2"
                      >
                        {{ modelControl_newPassword2 }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div slot="footer">
              <template v-if="handleSubPwdStepType == 1">
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="handleSubPwdStep2"
                >
                  下一步
                </button>
              </template>
              <template v-if="handleSubPwdStepType == 2">
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="handleSubPwd"
                >
                  确定
                </button>
              </template>
            </div>
          </template>
        </template>
        <template v-else-if="selectType == 2">
          <div slot="body">
            <form :ref="formDataRef">
              <div class="form-container-item">
                <div class="item-content item_content_mg_lf">
                  <div class="item-input-box">
                    <input
                      v-model="formData.name"
                      maxlength="20"
                      type="text"
                      prop="name"
                      placeholder="商家名"
                      :class="{ errorRules: modelControl.name }"
                      class="input__inner"
                    />
                    <div class="error-message" v-if="modelControl.name">
                      {{ modelControl.name }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-container-item">
                <div class="item-content item_content_mg_lf">
                  <div class="item-input-box">
                    <input
                      v-model="formData.shortName"
                      maxlength="20"
                      type="text"
                      prop="shortName"
                      placeholder="商家简称"
                      :class="{ errorRules: modelControl.shortName }"
                      class="input__inner"
                    />
                    <div class="error-message" v-if="modelControl.shortName">
                      {{ modelControl.shortName }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-container-item">
                <div class="item-content item_content_mg_lf">
                  <div class="item-input-box">
                    <input
                      v-model="formData.creditCode"
                      type="text"
                      prop="creditCode"
                      placeholder="统一社会信用代码"
                      :class="{ errorRules: modelControl.creditCode }"
                      class="input__inner"
                    />
                    <div class="error-message" v-if="modelControl.creditCode">
                      {{ modelControl.creditCode }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-container-item">
                <div class="item-content item_content_mg_lf">
                  <div class="item-input-box">
                    <div
                      class="file_img input__inner"
                      :class="{
                        file_img_after: formData.businessLicense,
                        errorRules: modelControl.businessLicense,
                      }"
                    >
                      <input
                        ref="fileRef"
                        type="file"
                        @change="handleChange"
                        prop="businessLicense"
                        class="input"
                      />
                      <img
                        v-if="formData.businessLicense"
                        :src="formData.businessLicense"
                        style="width: 100%; height: 100%"
                      />
                    </div>
                    <div
                      class="error-message"
                      v-if="modelControl.businessLicense"
                    >
                      {{ modelControl.businessLicense }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-container-item">
                <div class="item-content item_content_mg_lf">
                  <div class="item-input-box">
                    <div class="material-checkbox">
                      <input
                        type="checkbox"
                        v-model="payTypeArr"
                        :value="1"
                        checked
                      />
                      <span class="checkmark">银行卡支付</span>
                      <input type="checkbox" v-model="payTypeArr" :value="2" />
                      <span class="checkmark">支付宝支付</span>
                    </div>
                  </div>
                </div>
              </div>
              <template v-if="payTypeShow1">
                <span class="span-title">—— 银行卡支付信息 ——</span>
                <div class="form-container-item">
                  <div class="item-content item_content_mg_lf">
                    <div class="item-input-box">
                      <input
                        v-model="formData.bankName"
                        type="text"
                        prop="bankName"
                        placeholder="账户名称"
                        :class="{ errorRules: modelControl.bankName }"
                        class="input__inner"
                      />
                      <div class="error-message" v-if="modelControl.bankName">
                        {{ modelControl.bankName }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-container-item">
                  <div class="item-content item_content_mg_lf">
                    <div class="item-input-box">
                      <input
                        v-model="formData.accountName"
                        type="text"
                        prop="accountName"
                        placeholder="开户行"
                        :class="{ errorRules: modelControl.accountName }"
                        class="input__inner"
                      />
                      <div
                        class="error-message"
                        v-if="modelControl.accountName"
                      >
                        {{ modelControl.accountName }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-container-item">
                  <div class="item-content item_content_mg_lf">
                    <div class="item-input-box">
                      <input
                        v-model="formData.bankAccount"
                        type="text"
                        prop="bankAccount"
                        placeholder="银行账号"
                        :class="{ errorRules: modelControl.bankAccount }"
                        class="input__inner"
                      />
                      <div
                        class="error-message"
                        v-if="modelControl.bankAccount"
                      >
                        {{ modelControl.bankAccount }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="payTypeShow2">
                <span class="span-title">—— 支付宝支付信息 ——</span>
                <div class="form-container-item">
                  <div class="item-content item_content_mg_lf">
                    <div class="item-input-box">
                      <input
                        v-model="formData.accountName"
                        type="text"
                        prop="accountName"
                        placeholder="户名"
                        :class="{ errorRules: modelControl.accountName }"
                        class="input__inner"
                      />
                      <div
                        class="error-message"
                        v-if="modelControl.accountName"
                      >
                        {{ modelControl.accountName }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-container-item">
                  <div class="item-content item_content_mg_lf">
                    <div class="item-input-box">
                      <input
                        v-model="formData.alipayAccount"
                        type="text"
                        prop="alipayAccount"
                        placeholder="支付宝账号"
                        :class="{ errorRules: modelControl.alipayAccount }"
                        class="input__inner"
                      />
                      <div
                        class="error-message"
                        v-if="modelControl.alipayAccount"
                      >
                        {{ modelControl.alipayAccount }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <span class="span-title">—— 商家联系人信息 ——</span>
              <div class="form-container-item">
                <div class="item-content item_content_mg_lf">
                  <div class="item-input-box">
                    <input
                      v-model="formData.contacts"
                      maxlength="8"
                      type="text"
                      prop="contacts"
                      placeholder="联系人"
                      :class="{ errorRules: modelControl.contacts }"
                      class="input__inner"
                    />
                    <div class="error-message" v-if="modelControl.contacts">
                      {{ modelControl.contacts }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-container-item">
                <div class="item-content item_content_mg_lf">
                  <div class="item-input-box">
                    <input
                      v-model="formData.contactNumber"
                      maxlength="15"
                      type="text"
                      prop="contactNumber"
                      placeholder="联系电话"
                      :class="{ errorRules: modelControl.contactNumber }"
                      class="input__inner"
                    />
                    <div
                      class="error-message"
                      v-if="modelControl.contactNumber"
                    >
                      {{ modelControl.contactNumber }}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div slot="footer">
            <button class="btn btn-secondary" @click="showModal = false">
              取消
            </button>
            <button type="button" class="btn btn-primary" @click="handleSubMch">
              确定
            </button>
          </div>
        </template>
      </modelMask>
      <modelMask :showModal.sync="showModal2" :title="'提示'">
        <div slot="body">暂时无法使用，是否立即开通会员？</div>
        <div slot="footer">
          <button class="btn btn-secondary" @click="showModal2 = false">
            取消
          </button>
          <button type="button" class="btn btn-primary" @click="handleKaiTong">
            确定
          </button>
        </div>
      </modelMask>
      <pcPayment
        @payClose="payShow = false"
        :payModal="payShow"
        :pCouponId="pCouponId"
      ></pcPayment>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  uploadFiles,
  getOrderPage,
  getUserInfo,
  getPayQrCode,
  changeName,
  changePwdByPwd, // 修改密码
  checkPwd, // 旧密码 校验
  changePhonesendCode,
  changePhonecheckCode,
  changePhone,
  addMch,
  getUserPayOrderStatus,
  getCouponPageCanNot,
  getCouponPageCan,
} from "@/api/api";
import pcPayment from "../components/pcPayment.vue";
import Schema from "async-validator";
export default {
  name: "personCenter",
  components: {
    pcPayment,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      navsArr: [
        {
          img: require("../assets/images/set.png"),
          img_s: require("../assets/images/set_s.png"),
          text: "账户设置",
        },
        {
          img: require("../assets/images/merchant.png"),
          img_s: require("../assets/images/merchant_s.png"),
          text: "商家管理",
        },
        {
          img: require("../assets/images/orderRecord.png"),
          img_s: require("../assets/images/orderRecord_s.png"),
          text: "订单记录",
        },
        {
          img: require("../assets/images/coupon.png"),
          img_s: require("../assets/images/coupon_s.png"),
          text: "优惠券",
        },
      ],
      selectType: 1,
      businessLicense: "",
      phone: "15172443151",
      showModal: false,
      title: "",
      formObj: {
        quanType: 1,
      },
      quanTypeList: [
        { name: "不使用优惠券", value: 1 },
        { name: "100优惠券", value: 2 },
        { name: "200使用优惠券", value: 3 },
      ],
      editType: 1, //点击哪一种按钮，判断弹框显示内容
      modelControl_name: "", //校验提示内容
      modelControl_code: "",
      modelControl_newPhone: "",
      modelControl_password: "",
      modelControl_newPassword: "",
      modelControl_newPassword2: "",
      modelControl: {
        name: "",
        shortName: "",
        creditCode: "",
        businessLicense: "",
        bankName: "",
        accountName: "",
        bankAccount: "",
        alipayAccountName: "",
        alipayAccount: "",
        contacts: "",
        contactNumber: "",
        businessLicense: "",
      },
      formDataRef: "formDataRef",
      rules: {
        // name: [
        //   { required: true, message: '请输入商家名' },
        //   { required: true, pattern: /^[a-zA-Z0-9]{6,20}$/, min: 6, max: 20, message: '长度为6~20位, 可以使用数字、大小写字母', }
        // ],
        // creditCode: [
        //   { required: true, message: '请输入统一社会信用代码' },
        // ],
        // businessLicense: [
        //   { required: true, message: '请上传营业执照' },
        // ],
        name: [
          {
            required: true,
            message: `请输入商家名称`,
            trigger: ["blur", "change"],
          },
        ],
        shortName: [
          {
            required: true,
            message: `请输入商家简称`,
            trigger: ["blur", "change"],
          },
        ],
        bankName: [
          {
            required: true,
            message: `请输入户名`,
            trigger: ["blur", "change"],
          },
        ],
        accountName: [
          {
            required: true,
            message: `请输入开户行`,
            trigger: ["blur", "change"],
          },
        ],
        bankAccount: [
          {
            required: true,
            message: `请输入账号`,
            trigger: ["blur", "change"],
          },
        ],
        alipayAccountName: [
          {
            required: true,
            message: `请输入户名`,
            trigger: ["blur", "change"],
          },
        ],
        alipayAccount: [
          {
            required: true,
            message: `请输入支付宝账号`,
            trigger: ["blur", "change"],
          },
        ],
        contacts: [
          {
            required: true,
            message: `请输入联系人`,
            trigger: ["blur", "change"],
          },
        ],
        contactNumber: [
          {
            required: true,
            message: `请输入联系电话`,
            trigger: ["blur", "change"],
          },
        ],
      },
      sendCodeText: "获取验证码",
      isSendCodeActive: false,
      handleSubCodeStepType: 1, //修改手机号时的显示类型
      handleSubPwdStepType: 1, //修改密码时的显示类型
      userData: {
        name: "",
        code: "",
        newPhone: "",
        password: "",
        newPassword: "",
        newPassword2: "",
      },
      formData: {
        name: "",
        shortName: "",
        creditCode: "",
        businessLicense: "",
        bankName: "",
        accountName: "",
        bankAccount: "",
        alipayAccountName: "",
        alipayAccount: "",
        contacts: "",
        contactNumber: "",
      },
      payTypeArr: [1],
      payShow: false,
      userInfo: {},
      showModal2: false,
      orderTableData: [],

      useStatus: 1, // 优惠券可用状态1可，2不可
      dataList: [],
      pCouponId: "0", //券id默认为0不使用

      hasNextPage: false,
      pageNum: 1,
      mLoading: false,
    };
  },
  computed: {
    payTypeShow1: function () {
      return this.payTypeArr.includes(1);
    },
    payTypeShow2: function () {
      return this.payTypeArr.includes(2);
    },
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    ...mapActions(["logout"]),
    async loginOut() {
      let res = await this.logout();
      console.log(res);
      this.$router.push({
        path: "/login",
      });
    },
    fuck() {
      this.$toast({
        title: "提示",
        content: "您将发送警告消息",
        type: "success",
      });
    },
    fuck01() {
      this.$toast({
        title: "提示",
        content: "您将发送警告消息",
        type: "error",
      });
    },
    fuck02() {
      this.$toast({
        title: "提示",
        content: "您将发送警告消息",
        type: "warning",
      });
    },
    handleChange(file, warp) {
      console.log(this.$refs["fileRef"].files[0]);
      const uploadFile = this.$refs["fileRef"].files[0];
      const fileSize = uploadFile.size / 1024; // kb
      const fileName = uploadFile.name;

      let fileObj = {
        fileName: fileName,
        fileSize: fileSize.toFixed(1),
      };

      let formdata = new FormData();
      formdata.append("file", uploadFile);
      // formdata.append('title', fileName)
      // formdata.append('url', "d:/xxx")
      console.log(formdata.get("file"));

      uploadFiles(formdata)
        .then((res) => {
          if (res.status == 200) {
            this.formData.businessLicense = res.body[0];
            console.log(this.uploadImg, "uploadImg");
          }
        })
        .finally((e) => {});
    },

    // 切换nav
    handleNavItem(i) {
      this.selectType = ++i;
      if (this.selectType == 3) {
        this.getOrderPageFn();
      }
      if (this.selectType == 4) {
        this.dataList = []
        this.getCouponPageCanFn();
      }
    },
    handleKaiTong() {
      this.showModal2 = false;
      this.handleRenew();
    },
    // 去使用
    handleUse(item) {
      this.pCouponId = item.id;
      this.handleRenew();
    },
    // 续费
    handleRenew() {
      this.title = "支付信息";
      this.editType = 1;
      if (this.selectType == 1) {
        this.pCouponId = "0";
      }
      this.payShow = true;
    },
    handleEditNick() {
      this.title = "修改昵称";
      this.userData.name = this.userInfo.name;
      this.editType = 2;
      this.showModal = true;
    },
    handleEditPhone() {
      this.title = "修改手机号";
      this.editType = 3;
      this.showModal = true;
    },
    handleEditPsw() {
      this.title = "修改密码";
      this.editType = 4;
      this.showModal = true;
    },

    handleCreateMch() {
      if (this.userInfo.memberFlag) {
        this.title = "创建商家";
        this.showModal = true;
      } else {
        this.showModal2 = true
        // console.log("请先开通会员");
        // this.$toast({
        //   title: "提示",
        //   content: "请先开通会员",
        //   type: "warning",
        // });
      }
    },
    // 创建商家
    handleSubMch() {
      console.log(this.formData);
      let errors = this.rulesFunc(this.formDataRef, this.formData, this.rules);
      console.log(errors);
      errors
        .then((v) => {
          if (!v) {
            // console.log('通过')
            let data = Object.assign({}, this.formData);
            addMch(data)
              .then((res) => {
                if (res.status === 200) {
                  this.showModal = false;
                  this.$toast({
                    title: "",
                    content: "创建成功",
                    type: "success",
                  });
                }
              })
              .finally(() => {});
          } else {
            console.log("不通过");
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    handleLoginOut() {
      this.loginOut();
    },
    handleOpenWindow() {
      if (this.openUrl == "bbctest.yoogate.cn") {
        window.open("https://taxi.dev.yoogate.cn/main.html#/login");
      } else {
        window.open("https://taxi.yoogate.cn/main.html#/login");
      }
    },
    // 移动端订单记录详情
    hadnleOrderRecord(item) {
      let items = JSON.parse(JSON.stringify(item));
      this.$router.push({
        path: "/mOrderRecord",
        query: {
          items,
        },
      });
    },
    // 提交昵称
    handleSubName() {
      if (!this.userData.name) {
        this.modelControl_name = "请输入昵称";
        return;
      } else if (
        this.userData.name.length < 2 ||
        this.userData.name.length > 8
      ) {
        this.modelControl_name = "长度2-8字符";
        return;
      } else {
        this.modelControl_name = "";
        // 掉接口
        let data = {
          name: this.userData.name,
        };
        changeName(data).then((res) => {
          if (res.status == 200) {
            this.$toast({
              title: "",
              content: "修改成功",
              type: "success",
            });
            this.userInfo.name = this.userData.name;
            this.showModal = false;
          }
        });
      }
    },
    handleUseStatus() {
      this.useStatus = this.useStatus == 1 ? 2 : 1;
      this.pageNum = 1;
      this.dataList = [];
      this.getCouponPageCanFn();
    },
    handleSubCodeStep2() {
      if (!this.userData.code) {
        this.modelControl_code = "请输入验证码";
        return;
      } else {
        let data = {
          code: this.userData.code,
        };
        changePhonecheckCode(data).then((res) => {
          if (res.status == 200) {
            this.handleSubCodeStepType = 2;
          }
        });
      }
    },
    handleSubCode() {
      let reg_tel =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (
        !this.userData.newPhone ||
        this.userData.newPhone == this.userData.phone
      ) {
        this.modelControl_newPhone = "请输入新手机号码";
        return;
      } else if (!reg_tel.test(this.userData.newPhone)) {
        this.modelControl_newPhone = "请输入正确的新手机号码";
        return;
      } else {
        let data = {
          code: this.userData.code,
          phone: this.userData.newPhone,
        };
        changePhone(data).then((res) => {
          if (res.status == 200) {
            this.$toast({
              title: "",
              content: "修改成功",
              type: "success",
            });
            this.loginOut();
          }
        });
      }
    },

    handleSubPwdStep2() {
      if (!this.userData.password) {
        this.modelControl_password = "请输入原密码";
        return;
      } else {
        this.modelControl_password = "";
        let data = {
          oldPwd: this.userData.password,
        };
        checkPwd(data).then((res) => {
          if (res.status == 200) {
            this.handleSubPwdStepType = 2;
          }
        });
      }
    },
    // 修改密码提交
    handleSubPwd() {
      if (!this.userData.newPassword) {
        this.modelControl_newPassword = "请输入新密码";
        return;
      } else if (
        this.userData.newPassword.length < 6 ||
        this.userData.newPassword.length > 20
      ) {
        this.modelControl_newPassword =
          "6~20位，可以使用数字、大小写字母、特殊字符";
        return;
      } else if (!this.userData.newPassword2) {
        this.modelControl_newPassword = "";
        this.modelControl_newPassword2 = "请再次确认新密码";
        return;
      } else if (this.userData.newPassword != this.userData.newPassword2) {
        this.modelControl_newPassword2 = "两次密码输入不一致，请重新输入";
        return;
      } else {
        this.modelControl_newPassword2 = "";
        let data = {
          oldPwd: this.userData.password,
          password: this.userData.newPassword2,
        };
        changePwdByPwd(data).then((res) => {
          if (res.status == 200) {
            this.$toast({
              title: "",
              content: "修改成功",
              type: "success",
            });
            this.loginOut();
          }
        });
      }
    },
    sendCode() {
      changePhonesendCode()
        .then((res) => {
          if (res.status == 200) {
            this.$toast({
              title: "成功",
              content: "发送成功",
              type: "success",
            });
            this.isSendCodeActive = true;
            let num = 60;
            let timer = null;
            let sendCodeText = "60S";
            let _this = this;
            timer = setInterval(() => {
              if (num === 0) {
                clearInterval(timer);
                _this.sendCodeText = "获取验证码";
                _this.isSendCodeActive = false;
              } else {
                num--;
                sendCodeText = `${num}S`;
                _this.sendCodeText = sendCodeText;
              }
            }, 1000);
          }
        })
        .catch((err) => {
          this.isSendCodeActive = false;
        });
    },
    handleGetCode() {
      let _this = this;
      this.sendCode()
        .then((res) => {
          if (!res) {
            // this.$notify({
            //   type: 'success',
            //   title: '成功',
            //   message: '发送成功'
            // })
            this.$toast({
              title: "成功",
              content: "发送成功",
              type: "success",
            });
            this.isSendCodeActive = true;
            let num = 60;
            let timer = null;
            let sendCodeText = "60S";
            timer = setInterval(() => {
              if (num === 0) {
                clearInterval(timer);
                _this.sendCodeText = "获取验证码";
                _this.isSendCodeActive = false;
              } else {
                num--;
                sendCodeText = `${num}S`;
                _this.sendCodeText = sendCodeText;
              }
            }, 1000);
          }
        })
        .catch((err) => {
          this.isSendCodeActive = false;
        });
    },
    getUserInfo() {
      getUserInfo().then((res) => {
        if (res.status == 200) {
          this.userInfo = res.body;
          sessionStorage.setItem("userInfo", JSON.stringify(this.userInfo));
        }
      });
    },

    getOrderPageFn() {
      let params = {
        userId: this.userInfo.userId,
      };
      getOrderPage(params).then((res) => {
        if (res.status == 200) {
          this.orderTableData = res.body.dataList;
        }
      });
    },
    handleLoadingMore() {
      if (!this.hasNextPage) return;
      ++this.pageNum;
      this.mLoading = true;
      console.log(this.pageNum);
      this.getCouponPageCanFn();
    },
    getCouponPageCanFn() {
      let params = {
        pageNum: this.pageNum,
        pageSize: 15,
      };
      let requests =
        this.useStatus == 1
          ? getCouponPageCan(params)
          : getCouponPageCanNot(params);
      requests.then((res) => {
        if (res.status == 200) {
          let body = res.body.dataList || [];
          this.dataList.push(...body);
          this.hasNextPage = res.body.hasNextPage;
          this.pageNum = res.body.pageNum;
          this.mLoading = false;
        }
      });
    },
    handleBlurRules(e) {
      console.log(e);
      const prop = e.target.attributes.prop.value;
      if (!prop) {
        return false;
      }
      this.rulesFunc(this.formDataRef, this.formData, this.rules);
    },
    rulesFunc(formDataRef, formData, rules) {
      let fieldsArr = [];
      let newfields = {};
      for (let key1 of this.$refs[formDataRef]) {
        let attributesArr = key1.getAttribute("prop");
        fieldsArr.push(attributesArr);
      }
      fieldsArr.forEach((el) => {
        if (this.rules[el]) {
          newfields[el] = rules[el];
        }
      });
      this.validator = new Schema(newfields);
      let errors = this.validator
        .validate(formData)
        .then((value) => {
          // 校验通过
          this.modelControl = {};
        })
        .catch(({ errors, fields }) => {
          // this.modelControl[prop] = fields[prop][0].message;
          let modelControl = {};
          for (let key in fields) {
            modelControl[key] = fields[key][0].message;
          }
          this.modelControl = modelControl;
          return errors;
        });
      return errors;
    },
  },
};
</script>

<style lang="scss" scoped>
.personCenter {
  width: 100%;
  min-height: calc(100vh - 8.5417rem);
  box-sizing: border-box;
  margin: 0 auto;
  padding: 0.8333rem;
  background-color: rgba(204, 213, 222, 0.5);
}
.personCenter_content {
  width: 1200px;
  height: 768px;
  box-sizing: border-box;
  margin: 0 auto;
  /* #FFFFFF */
  background: rgb(255, 255, 255);
  /* #DDDDDD */
  border: 1px solid rgb(221, 221, 221);
  /* 卡片阴影 */
  box-shadow: 0px 4px 14px 0px rgba(204, 213, 222, 0.5);
  border-radius: 4px 0px 0px 0px;
  display: flex;
}
.personCenter_content_left {
  width: 192px;
  height: 100%;
  list-style-type: none;
  padding-left: 0;
}
.personCenter_content_left > li {
  margin-top: 24px;
  // height: 48px;
  cursor: pointer;
  padding: 0.8em 1.8em;
  // border: 2px solid #17C3B2;
  position: relative;
  overflow: hidden;
  background-color: transparent;
  text-align: center;
  font-size: 16px;
  transition: 0.3s;
  z-index: 1;
  color: #808da1;
  border-radius: 0px 8px 8px 0px;
}

.personCenter_content_left > li::before {
  content: "";
  width: 0;
  height: 300%;
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(0%, 0%);
  background-color: #eff5ff;
  transition: 0.3s ease;
  display: block;
  z-index: -1;
}

// .personCenter_content_left> li:hover::before {
//  width: 105%;
// }

// .personCenter_content_left> li:hover {
//  color: #6696FF;

// }
.personCenter_content_left > li.nav_item_s::before {
  width: 100%;
}

.personCenter_content_left > li.nav_item_s {
  color: #6696ff;
}
.nav_item {
  width: 124px;
  height: 24px;
  display: flex;
  align-items: center;
}
.nav_item > .icon {
  width: 24px;
  height: 24px;
}
.nav_item > .icon + div {
  margin-left: 30px;
  font-size: 16px;
  line-height: 1;
}

.personCenter_content_right {
  width: 1007px;
  height: 100%;
  // background: rgba(0, 0, 0, 0.2);
  overflow: hidden;
  padding: 40px;
  box-sizing: border-box;
  & > div {
    height: 100%;
  }
  .scroll_none {
    overflow-y: scroll;
  }
  .scroll_none::-webkit-scrollbar {
    display: none;
  }
  .content_right_box {
    & > div {
      height: 58px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-bottom: 40px;
    }

    .loginOut {
      display: inline-block;
      width: 190px;
      height: 40px;
      box-sizing: border-box;
      background: rgb(231, 0, 0);
      border: 1px solid rgb(231, 0, 0);
      border-radius: 4px;
      font-size: 16px;
      font-weight: 400;
      line-height: 40px;
      text-align: center;
      color: #ffffff;
    }
    .right_item_title {
      color: #333333;
      font-family: PingFang SC;
      font-size: 18px;
      font-weight: 400;
      line-height: 26px;
    }
    .right_item_detail {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      .right_item_detail_lf {
        display: flex;
        align-items: center;
        color: #808da1;
        flex: 1;
        & > div {
          line-height: 1;
          margin-left: 14px;
        }
      }
      .right_item_detail_rt {
        color: #6696ff;
        flex: 1;
        cursor: pointer;
      }
    }
  }
}

.btn {
  display: inline-block;
  font-weight: 400;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  background-color: transparent;
  border: none;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  outline: none;
}
.btn-primary {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}
.btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.modal_footer .btn + .btn {
  margin-bottom: 0;
  margin-left: 10px;
}
.nickname-wrapper {
  display: flex;
  align-items: center;
  padding: 40px 30px;
}
.form-container-item {
  margin-bottom: 20px;
}
.form-container-item > .item-content {
  width: 440px;
}
.input__inner,
.getcode-button {
  height: 46px;
  line-height: 46px;
}
.getcode-button {
  width: 160px;
  font-size: inherit;
}
.span-title {
  display: block;
  margin-left: 40px;
  margin-bottom: 10px;
}
// 多选样式
.material-checkbox {
  display: flex;
  align-items: center;
  font-size: 16px;
  margin: 5px 0;
  color: #777777;
  cursor: pointer;
}
.material-checkbox .checkmark {
  margin-right: 15px;
}
.material-checkbox input[type="checkbox"] {
  margin: 4px;
}

.file_img {
  position: relative;
  width: 200px;
  height: 150px;
  // background-color: #ccc;
  border: 1px solid #dcdfe6;
  padding: 0;
}
// .file_img::before {
//   position: absolute;
//   top: 50%;
//   left: 50%;
//   content: "+";
//   font-size: 36px;
//   color: #dcdfe6;
//   transform: translate(-50%, -50%);
// }
.file_img::after {
  position: absolute;
  top: 50%;
  left: 50%;
  content: "营业执照";
  font-size: 16px;
  color: #dcdfe6;
  white-space: nowrap;
  transform: translate(-50%, -50%);
}
.file_img:hover:after {
  content: "拖拽或点击上传 ";
}
.file_img.file_img_after::after {
  content: "";
}
.file_img input {
  display: block;
  height: 100%;
  width: 100%;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
}
.file_img .img {
  position: absolute;
  top: 0;
  left: 0;
  width: 200px;
  height: 150px;
}

// 订单记录表格样式
.table-td1 {
  text-align: center;
  padding: 12px 4px;
  height: 100%;
}
.th-div {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 15px;
  color: #808da1;
  font-size: 14px;
}
.table-td2 {
  text-indent: 1rem;
}
table {
  width: 100%;
  border-color: #ebeef5;
  font-size: 16px;
}
table td {
  border-color: #ebeef5;
}
.table-td1_name {
  color: #333333;
}
.table-td1_qixian {
  color: #808da1;
  font-size: 12px;
  font-weight: 400;
}
.body_tr:hover {
  background-color: #f5f7fa;
  transition: background-color 0.25s ease;
}
.tableNone {
  text-align: center;
  border: 1px solid #ebeef5;
  border-top: none;
  padding: 12px 4px;
  color: #808da1;
}
.selectType4_params {
  color: #6696ff;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 400;
  padding: 15px 0;
  cursor: pointer;
}
.loadingMore {
  text-align: center;
  padding: 2.6667rem;
  cursor: pointer;
}
.mOrderRecord_box,
.coupon_box {
  display: none;
}
@media screen and (min-width: 300px) and (max-width: 768px) {
  .content-banner-box {
    display: none;
  }
  .personCenter {
    padding: 0;
    min-height: calc(100vh - 100px);
    background-color: #fff;
  }
  .personCenter_content {
    width: 100%;
    box-sizing: border-box;
    margin: 0 auto;
  }
  .personCenter_content {
    height: 100%;
    flex-direction: column;
    box-shadow: none;
    border: none;
  }
  .personCenter_content_left {
    width: 100%;
    display: flex;
  }
  .personCenter_content_left > li {
    flex: 1;
    border-radius: 0;
    font-size: $mFontSize24;
    padding: 3.2rem 0;
    font-size: 3.2rem;
  }
  .personCenter_content_left > li::before {
    transition: none;
  }
  .nav_item {
    width: 100%;
    justify-content: center;
  }
  .nav_item > .icon {
    display: none;
  }
  .nav_item > .icon + div {
    margin-left: 0;
    font-size: 3.2rem;
    line-height: 1;
  }
  .personCenter_content_right {
    width: 100%;
    // padding: $mFontSize24;
    padding: 0;
  }
  .personCenter_content_right {
    height: 100%;
    // background: rgba(0, 0, 0, 0.2);
    overflow: hidden;
    padding: 0;
    box-sizing: border-box;
    & > div {
      height: 100%;
    }
    .scroll_none {
      overflow-y: scroll;
    }
    .scroll_none::-webkit-scrollbar {
      display: none;
    }
    .content_right_box {
      & > div {
        height: 15.4667rem;
        padding: 2.6667rem 3.2rem;
        margin-bottom: 0;
        border-bottom: 1px solid #dddddd;
      }
      & > .loginOut_box {
        border-bottom: none;
      }

      .loginOut {
        display: inline-block;
        width: 93.3333rem;
        height: 11.7333rem;
        margin: 0 auto;
        box-sizing: border-box;
        background: rgb(231, 0, 0);
        border: 1px solid rgb(231, 0, 0);
        border-radius: 0.5333rem;
        font-size: 3.7333rem;
        font-weight: 400;
        line-height: 11.7333rem;
        text-align: center;
        color: #ffffff;
      }
      .right_item_title {
        color: #333333;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 3.7333rem;
        line-height: 3.7333rem;
      }
      .right_item_detail {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 3.2rem;
        line-height: 3.2rem;
        .right_item_detail_lf {
          display: flex;
          align-items: center;
          color: #808da1;
          flex: 1;
          & > div {
            line-height: 1;
            margin-left: 0;
          }
          & > .icon {
            display: none;
          }
        }
        .right_item_detail_rt {
          color: #6696ff;
          flex: 1;
          text-align: right;
          cursor: pointer;
        }
      }
    }
  }
  .btn {
    display: inline-block;
    font-weight: 400;
    color: #212529;
    text-align: center;
    vertical-align: middle;
    user-select: none;
    background-color: transparent;
    border: none;
    font-size: 4.2667rem;
    line-height: 1.5;
    border-radius: 4px;
    outline: none;
  }

  .btn-primary {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
  }

  .btn-secondary {
    color: #fff;
    background-color: #6c757d;
    border-color: #6c757d;
  }

  .modal_footer .btn + .btn {
    margin-bottom: 0;
    margin-left: 2.6667rem;
  }

  .form-container-item > .item-content {
    width: 82.9333rem;
  }
  .form-container {
    padding: 4.2667rem 0;
    font-size: 3.7333rem;
  }
  .form-container-item {
    margin-bottom: 5rem;
  }
  .file_img {
    width: 53.3333rem !important;
    height: 40rem !important;
    border: 1px solid #dcdfe6;
    padding: 0 !important;
  }
  .input__inner {
    border-radius: 1.0667rem;
    border: 1px solid #dcdfe6;
    height: 10.6667rem;
    line-height: 10.6667rem;
    padding: 0 3.2rem;
    width: 100%;
    font-size: 4.2667rem;
  }
  .input__inner.errorRules {
    border: 1px solid red !important;
  }
  .error-message {
    padding-top: 0.2667rem;
    font-size: 2.4rem;
  }
  .item-content > .item-label,
  .form-container-item > .item-content {
    line-height: 10.6667rem;
  }
  .form-button {
    border-radius: 1.0667rem;
    border: 1px solid #0069ea;
    padding: 2.8rem;
    font-size: 3.7333rem;
    font-weight: 400;
    line-height: 5.6rem;
  }
  .content-tab > div {
    margin-right: 4.2667rem;
  }
  .login-footer-container {
    font-size: 3.7333rem;
  }
  .getcode-button {
    position: absolute;
    right: 0;
    top: 0;
    white-space: nowrap;
    height: 10.6667rem;
    line-height: 100%;
    cursor: pointer;
    border: none;
    border-radius: 0 1.0667rem 1.0667rem 0;
    // padding: 16px 27px;
    box-sizing: border-box;
    outline: 0;
    transition: 0.1s;
    font-weight: 500;
    background-color: #0069ea;
    color: #fff;
    width: 25.0667rem;
    font-size: 3.7333rem;
  }

  // 订单记录表格样式
  table {
    display: none;
  }
  // .table-td1 {
  //   text-align: center;
  //   padding: 3.2rem 1.6rem;
  //   height: 100%;
  // }
  // .th-div {
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   padding: 0px 4rem;
  //   color: #808da1;
  //   font-size: 1.8667rem;
  //   white-space: nowrap;
  // }
  // .table-td2 {
  //   text-indent: 1rem;
  // }
  // table {
  //   border-color: #ebeef5;
  //   font-size: 2.1333rem;
  // }
  // table td {
  //   border-color: #ebeef5;
  // }
  // .table-td1_name {
  //   color: #333333;
  // }
  // .table-td1_qixian {
  //   color: #808da1;
  //   font-size: 1.6rem;
  //   font-weight: 400;
  // }
  // .body_tr:hover {
  //   background-color: #f5f7fa;
  //   transition: background-color 0.25s ease;
  // }
  // .tableNone {
  //   text-align: center;
  //   border: 1px solid #ebeef5;
  //   border-top: none;
  //   padding: 1.6rem .5333rem;
  //   color: #808da1;
  // }
  .selectType4_params {
    color: #6696ff;
    font-family: PingFang SC;
    font-size: 1.8667rem;
    font-weight: 400;
    padding: 2rem 2rem;
    cursor: pointer;
  }
  .loadingMore {
    text-align: center;
    cursor: pointer;
  }
  // 移动端订单记录
  .mOrderRecord_box {
    display: block;
    width: 100%;
    height: 100%;
    padding-bottom: 4rem;
    .mOrderRecord_item {
      // height: 13.8667rem;
      padding: 3.2rem 3.2rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 3.7333rem;
      border-bottom: 1px solid #dddddd;
      box-sizing: border-box;
      .mOrderRecord_item_lf {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        & > div:not(.mOrderRecord_item_lf_name) {
          font-size: 3.2rem;
          color: #666666;
        }
        .mOrderRecord_item_lf_name {
          line-height: 2;
        }
      }
      .mOrderRecord_item_rt {
        color: #0069ea;
      }
    }
  }
  
  // 移动端优惠券
  .coupon_box {
    display: block;
    width: 100%;
    height: 100%;
    padding-bottom: 4rem;
    .coupon_item {
      // height: 13.8667rem;
      padding: 3.2rem 3.2rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 3.7333rem;
      border-bottom: 1px solid #dddddd;
      box-sizing: border-box;
      .coupon_item_lf {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        // &>div:not(.coupon_item_lf_name) {
        //   font-size: 3.2rem;
        //   color: #666666;
        // }
        .coupon_item_lf_lf {
          width: 24rem;
          padding-right: 3.2rem;
          font-size: 5.3333rem;
          color: #808da1;
          text-align: center;
          .coupon_item_lf_lf_fuhao {
            font-size: 3.7333rem;
          }
        }
        .coupon_item_lf_lf.useStatus1 {
          color: #e70000;
        }
        .coupon_item_lf_rt {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          & > div:not(.coupon_item_lf_rt_name) {
            font-size: 3.2rem;
            color: #666666;
          }
          .coupon_item_lf_rt_name {
            line-height: 2;
          }
        }
      }
      .coupon_item_rt {
        color: #0069ea;
      }
    }
  }
}
</style>
